import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../core/guard/auth.guard';
import { AverageByEquipmentComponent } from './equipment-usage/average-by-equipment/average-by-equipment.component';
import { AverageByTimeComponent } from './equipment-usage/average-by-time/average-by-time.component';
import { UsageByDayComponent } from './equipment-usage/usage-by-day/usage-by-day.component';
import { StatsComponent } from './stats.component';

const routes: Routes = [
  { 
    path: '', 
    component: StatsComponent, 
    canActivate: [AuthGuard],
    data: {
      meta: {
        title: '',
        breadcrumb: ['MENU.STATS'],
      },
    }, 
  },
  { 
    path: 'averageByDay', 
    component: UsageByDayComponent, 
    canActivate: [AuthGuard]
  },
  { 
    path: 'averageByTime', 
    component: AverageByTimeComponent, 
    canActivate: [AuthGuard]
  },
  { 
    path: 'averageByEquipment', 
    component: AverageByEquipmentComponent, 
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StatsRoutingModule {}
